module.exports = __webpack_public_path__ + "static/media/icon-mySql.b645638c.svg";